import z from 'zod';

export const PlatformUsageTeam = z.object({
    id: z.string(),
    name: z.string(),
    editorMinutes: z.number(),
});

export type PlatformUsageTeam = z.infer<typeof PlatformUsageTeam>;

export const PlatformUsageTeamsResponse = z.object({
    teams: z.array(PlatformUsageTeam),
});

export type PlatformUsageTeamsResponse = z.infer<typeof PlatformUsageTeamsResponse>;
